// Purchase-summary links reveal their existing policy before scrolling to it.
document.addEventListener('click', (event) => {
  const link = event.target.closest('.hx-policy-summary a[href^="#hx-support-"]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!(target instanceof HTMLDetailsElement)) return;
  event.preventDefault();
  target.open = true;
  target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  target.querySelector('summary')?.focus({ preventScroll: true });
});
